<template>
    <a-row class="mt10">
        <a-col :span = "2">
            <label class="foldText">{{rowIndex}}</label>
        </a-col>
        <a-col :span = "19">
            <a-select size="small" show-search v-model="field" @change="fieldChange" :disabled="rowIndex==1">
                <a-select-option :key="item.code" :value="item.code" v-for="(item,index) in detailCartonDisplayInfoFieldItems">{{item.value}}</a-select-option>
            </a-select>
        </a-col>
    </a-row>
</template>
<script>
    export default {
        props:['index','detailCartonDisplayInfoFieldItems','infoFielditem'],
        data() {
            return {
                field:this.infoFielditem,
                rowIndex:this.index+1,
            }
        },
        methods:{
            fieldChange() {
                this.$emit('detailCartonFieldChange',this.index, this.field)
            }
        }


    };
</script>